// acciones
export const SAGA_GET_OFERTAS = 'ofertaReducer/SAGA_GET_OFERTAS'
export const SET_OFERTAS = 'ofertaReducer/SET_OFERTA'
export const SAGA_GET_OFERTASBYID = 'ofertaReducer/SAGA_GET_OFERTASBYID'
export const SET_OFERTABYID = 'ofertaReducer/SET_OFERTABYID'
export const SAGA_BORRAR_OFERTA = 'ofertaReducer/SAGA_BORRAR_OFERTA'
export const SET_OFERTA_INACTIVO = 'ofertaReducer/SET_OFERTA_INACTIVO'
export const SAGA_SAVE_OFERTA = 'ofertaReducer/SAGA_SAVE_OFERTA'
export const SAGA_SWAP_OFERTA = 'ofertaReducer/SAGA_SWAP_OFERTA'
export const SET_OFERTA_SELECTED = 'ofertaReducer/SET_OFERTA_SELECTED'
export const SAGA_PUT_OFERTA = 'ofertaReducer/SAGA_PUT_OFERTA'
export const SAGA_GET_OFERTAS_ACTIVAS = 'ofertaReducer/SAGA_GET_OFERTAS_ACTIVAS'

// funciones
export const setOfertaSelected = (payload) => ({
  type: SET_OFERTA_SELECTED,
  payload,
})

export const sagaGetOfertas = () => ({
  type: SAGA_GET_OFERTAS,
})

export const sagaGetOfertasActivas = () => ({
  type: SAGA_GET_OFERTAS_ACTIVAS,
})

export const setOferta = (payload) => ({
  type: SET_OFERTAS,
  payload,
})

/*
export const sagaGetOfertas = (payload) =>{
return {
    type: SAGA_GET_OFERTAS,
    payload
}}
*/
export const setOfertaById = (payload) => {
  return {
    type: SET_OFERTABYID,
    payload,
  }
}

export const sagaBorrarOferta = (payload) => ({
  type: SAGA_BORRAR_OFERTA,
  payload,
})

export const setOfertaInactivo = (payload) => ({
  type: SET_OFERTA_INACTIVO,
  payload,
})

export const sagaSabeOferta = (payload) => ({
  type: SAGA_SAVE_OFERTA,
  payload,
})

export const sagaSwapOferta = (payload) => ({
  type: SAGA_SWAP_OFERTA,
  payload,
})

export const sagaPutOferta = (payload) => ({
  type: SAGA_PUT_OFERTA,
  payload,
})
